import React from "react"
import cx from "classnames"
import { CobaltBreakpointType } from "../../hooks/useBreakpoint"

export type HorizontalListPropsType = {
  children?: React.ReactNode
  className?: string
  fitFrom?: Exclude<CobaltBreakpointType, "over">
}

export default function HorizontalList({
  className,
  fitFrom,
  children,
}: HorizontalListPropsType) {
  return (
    <div
      className={cx(`cobalt-horizontal-list`, className, {
        "xs:cobalt-horizontal-list--fit": fitFrom === "xs",
        "sm:cobalt-horizontal-list--fit": fitFrom === "sm",
        "md:cobalt-horizontal-list--fit": fitFrom === "md",
        "lg:cobalt-horizontal-list--fit": fitFrom === "lg",
      })}
    >
      {children}
    </div>
  )
}

type HorizontalScrollerPaddingBlockProps = {
  className?: string
}

export function HorizontalListPaddingBlock({
  className,
}: HorizontalScrollerPaddingBlockProps) {
  return (
    <div
      className={cx(`cobalt-horizontal-list__padding-block`, className)}
    ></div>
  )
}
